import * as React from 'react';
import * as moment from 'moment';
import { Icon } from '@ridi/rsg';

interface Props {
  intervalHours: number;
  availableAt: string;
  close: () => void;
}

interface State {
  duration: moment.Duration;
  remaining: string;
  ratio: number;
}

export class WaitFreeTimer extends React.Component<Props, State> {
  private timeout: number;

  constructor(props: Props) {
    super(props);
    this.state = this.getUpdatedState();
  }

  getUpdatedState(): State {
    const availableAt = moment(this.props.availableAt);
    const duration = moment.duration(availableAt.diff(moment()));
    const milliseconds = duration.as('milliseconds');
    const units = ['일', '시간', '분'];

    if (milliseconds < 1000) {
      this.props.close();
      return;
    }

    const milliSecondsToNextMin = milliseconds % 60000;

    this.timeout = window.setTimeout(() => {
      const state = this.getUpdatedState();
      state && this.setState(state);
    }, milliSecondsToNextMin);

    if (milliSecondsToNextMin > 0) {
      duration.add(1, 'm');
    }

    return {
      duration,
      remaining: [
        duration.days(),
        duration.hours(),
        duration.minutes(),
      ].reduce((acc, cur, i) => {
        cur && acc.push(cur + units[i]);
        return acc;
      }, []).join(' '),
      ratio: duration.as('hours') / this.props.intervalHours,
    };
  }

  componentWillUnmount() {
    window.clearTimeout(this.timeout);
  }

  render() {
    return (
      <div className="BookDetailWaitFree_Timer">
        <Icon
          name="clock_1"
          className="BookDetailWaitFree_Timer_Icon"
        />
        <span className="BookDetailWaitFree_Timer_Remaining">
          {this.state.remaining} 남음
        </span>
        <div className="BookDetailWaitFree_Timer_ProgressBar">
          <div
            className="BookDetailWaitFree_Timer_ProgressBar_Filled"
            style={{ width: `${(1 - this.state.ratio) * 100}%` }}
          />
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./pages/bookDetail/components/WaitFreeTimer.tsx